import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangBat2fa } from './pages/TrangBat2fa.js';
import { TrangTaiKhoan } from './pages/TrangTaiKhoan.js';
import { UiKitPage } from './pages/UiKitPage.js';

/**
 * Module 00 không có mục menu riêng: nó là khung chứa cho các module khác.
 * Route `/` nay thuộc module 11 (`dashboard`); route `/ui` chỉ bật ở môi trường dev.
 *
 * `/tai-khoan` **không khai quyền**: ai đăng nhập cũng vào được để đổi mật khẩu
 * và email của chính mình. Vào từ thẻ người dùng ở góc dưới thanh bên.
 */
const core: KhaiBaoModule = {
  id: 'core',
  routes: [
    { path: '/tai-khoan', element: createElement(TrangTaiKhoan) },
    /*
     * Bật 2FA **tự nguyện**. Cùng màn mà `CanDangNhap` dựng khi ép bật, nên có
     * một đường dẫn thật để người chưa bị ép vẫn bật được, và để bài E2E mở
     * thẳng luồng này mà không cần dựng một tài khoản đang bị ép.
     */
    { path: '/bat-2fa', element: createElement(TrangBat2fa) },
    ...(import.meta.env.DEV ? [{ path: '/ui', element: createElement(UiKitPage) }] : []),
  ],
};

export default core;
